<template>
  <div class="sign-info">
    <role-tab v-if="showMenuTree" :ywtTab="true"/>
    <div v-if="showMenuTree" class="main-wrap">
      <div class="left-wrap">
        <template v-if="!isInDingTalk && !APIpath">
          <publish-sign
            v-if="currentAuthUser.userStemFrom !== -16"
            class="publish"
            fileText="发起签署"
            tplText="模板发起签署"
          />
          <div v-else class="dindin_code">
            <img
              src="../static/images/dindin_code.png"
              class="code_img"
              alt=""
            />
          </div>
        </template>
        <!--  非API对接      -->
        <template v-if="!APIpath">
          <el-tabs
            v-model="tabsActive"
            :stretch="true"
            v-if="
            getPerms.includes(5) && $store.getters.currentAuthUser.userType != 0
          "
          >
            <!-- tabs 1 start -->
            <el-tab-pane label="企业办理的" name="contract">
              <!--            <publish-sign-->
              <!--              class="publish"-->
              <!--              fileText="文件发起签署"-->
              <!--              tplText="模板发起签署"-->
              <!--            />-->
              <apply-menu-tree
                :defaultExpandedKeys="['changeUserInfo']"
                class="menu-tree"
                ref="menuTree"
                :currentMenuName.sync="currentMenuName"
                :initCallback="initMenuTree"
                :menus="menus"
              />
            </el-tab-pane>
            <!-- tabs 1 end -->
            <!-- tabs 2 start -->
            <el-tab-pane
              v-if="getPerms.includes(gantConf.memberFile)"
              label="成员经办的"
              name="overview"
            >
              <contract-tab-left></contract-tab-left>
            </el-tab-pane>
            <!-- tabs 2 end -->
          </el-tabs>
          <div v-else>
            <!--          <publish-sign-->
            <!--            class="publish"-->
            <!--            fileText="文件发起签署"-->
            <!--            tplText="模板发起签署"-->
            <!--          />-->
            <apply-menu-tree
              :defaultExpandedKeys="['changeUserInfo']"
              class="menu-tree"
              ref="menuTree"
              :currentMenuName.sync="currentMenuName"
              :initCallback="initMenuTree"
              :menus="menus"
              :style="{ height: 'calc(100% - 100px)' }"
            />
          </div>
        </template>
        <!--   API对接     -->
        <template v-else>
          <apply-menu-tree
            :defaultExpandedKeys="['changeUserInfo']"
            class="menu-tree"
            ref="menuTree"
            :currentMenuName.sync="currentMenuName"
            :initCallback="initMenuTree"
            :menus="menus"
          />
        </template>
      </div>
      <contarct-table
        v-show="tabsActive == 'overview'"
        class="right-wrap"
      ></contarct-table>
      <div class="right-wrap" v-show="tabsActive == 'contract'">
        <route-name
          :propsRouteName="computedCurrentMenuName"
          :style="{
            fontSize: '16px',
            lineHeight: '36px',
            backgroundColor: '#fff',
            paddingLeft: '16px',
            fontWeight: '600',
            borderBottom: 'solid 1px #E5E5E5',
          }"
        />
        <div id="nuxt-view">
          <nuxt-child
            :badge.sync="badge"
            ref="rightWrap"
            @batchLength="batchLength"
            :currentPathDirType="currentPathDirType"
            :showDirBtn="showDirBtn"
            @emitFn="emitFn"
            @removeFromDir="removeFromDir"
          />
        </div>
        <!--        1361历史按钮-->
        <!--        <el-button-->
        <!--          v-if="showDirBtn"-->
        <!--          style="position: absolute; top: 110px; left: 240px; z-index: 1000;"-->
        <!--          size="mini"-->
        <!--          @click="saveToDir"-->
        <!--          >归档-->
        <!--        </el-button>-->
        <!--        &lt;!&ndash; 历史文件移动到 收件箱里面 &ndash;&gt;-->
        <!--        <el-button-->
        <!--          v-if="$route.query.match"-->
        <!--          @click="toHistory"-->
        <!--          v-show="-->
        <!--            $store.getters.currentAuthUser.userType == 1 &&-->
        <!--              $route.path.indexOf('signList') > -1-->
        <!--          "-->
        <!--          style="position: absolute; bottom: 20px; left: 15px; z-index: 1000;margin-left: 0"-->
        <!--          size="mini"-->
        <!--          >历史文件</el-button-->
        <!--        >-->
        <!--        &lt;!&ndash; 收件箱归档列表里面添加归档(移动)和物理删除按钮 &ndash;&gt;-->
        <!--        <template-->
        <!--          v-if="currentPathDirType === 2 && $route.query.directoryId && batch"-->
        <!--        >-->
        <!--          <div-->
        <!--            style="position: absolute; top: 108px; left: 395px; z-index: 1000;"-->
        <!--          >-->
        <!--            &lt;!&ndash; 新添加 &ndash;&gt;-->
        <!--            <el-button @click="dirMove()" size="small">归档</el-button>-->
        <!--            <el-button @click="physicsDelete()" size="small">删除</el-button>-->
        <!--          </div>-->
        <!--        </template>-->
        <!--        <template-->
        <!--          v-if="currentPathDirType === 1 && $route.query.directoryId && batch"-->
        <!--        >-->
        <!--          <div-->
        <!--            style="position: absolute; top: 108px; left: 240px; z-index: 1000;"-->
        <!--          >-->
        <!--            &lt;!&ndash; 新添加 &ndash;&gt;-->
        <!--            <el-button @click="dirMove()" size="mini">归档</el-button>-->
        <!--            &lt;!&ndash; <el-button  @click="removeFromDir()" size="small">移除</el-button> &ndash;&gt;-->
        <!--          </div>-->
        <!--        </template>-->
        <!--        &lt;!&ndash; 草稿箱添加删除按钮 &ndash;&gt;-->
        <!--        <template v-if="$route.query.signStatus == '4' && batch">-->
        <!--          <div-->
        <!--            style="position: absolute; top: 108px; left: 240px; z-index: 1000;"-->
        <!--          >-->
        <!--            <el-button @click="deleteFromDir()" size="small">删除</el-button>-->
        <!--          </div>-->
        <!--        </template>-->
      </div>
      <el-dialog
        :visible.sync="dialogFormVisible"
        :title="currentDir.directoryId ? '重命名归档文件夹' : '添加归档文件夹'"
        :close-on-click-modal="false"
        width="460px"
      >
        <el-row style="margin: 10px 20px">
          <el-col :span="3">
            <span style="vertical-align: middle">名称：</span>
          </el-col>
          <el-col :span="21">
            <el-input placeholder="请输入文件夹名称" v-model="currentDir.name" size="small" :maxlength="10"/>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small"
          >取消
          </el-button
          >
          <el-button @click="createOrUpdateDir()" size="small" type="danger"
          >确定
          </el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="showAllDirs"
        class="dialog-height"
        title="选择归档文件夹"
        :close-on-click-modal="false"
        width="460px"
      >
        <ul class="move-to-dir">
          <!--归档文件夹-->
          <template v-if="currentPathDirType === 1">
            <li
              v-for="(folder, index) in dirList"
              :key="'sent-folder-' + index"
              @click="chooseFolder(folder, index)"
              :class="{ active: choosenFolder.index === index }"
            >
              <div>
                <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
                {{ folder.label }}
              </div>
            </li>
          </template>

          <!--收件箱-->
          <template v-if="currentPathDirType === 2">
            <li
              v-for="(folder, index) in receivedDirList"
              :key="'received-folder-' + index"
              @click="chooseFolder(folder, index)"
              :class="{ active: choosenFolder.index === index }"
            >
              <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
              {{ folder.label }}
            </li>
          </template>
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showAllDirs = false" size="small">取消</el-button>
          <el-button @click="saveApplySignToDir()" size="small" type="danger"
          >确定
          </el-button
          >
        </div>
      </el-dialog>
      <!-- 移动归档 -->
      <el-dialog
        :visible.sync="moveDirVisible"
        class="dialog-height"
        title="选择归档文件夹"
        :close-on-click-modal="false"
        width="460px"
      >
        <ul class="move-to-dir">
          <!--收件箱-->
          <li
            v-for="(folder, index) in moveDirList"
            :key="'received-folder-' + index"
            :class="{ active: choosenFolder.index === index }"
            @click="chooseFolder(folder, index)"
          >
            <span v-if="folder.nodeIcon" :class="folder.nodeIcon"></span>
            {{ folder.label }}
          </li>
        </ul>
        <div slot="footer" class="dialog-footer">
          <el-button @click="moveDirVisible = false" size="small"
          >取消
          </el-button
          >
          <el-button @click="moveApplySignToDir()" size="small" type="danger"
          >确定
          </el-button
          >
        </div>
      </el-dialog>
    </div>
    <template v-else>
      <nuxt-child/>
    </template>
  </div>
</template>

<script>
  import Bus from "@/plugins/bus.js";
  // 接口
  import {configUrl} from "@/assets/js/http-serve/http-methods";
  import {ApiMethods} from "@/assets/js/http-serve/http-methods";
  import {delSignBySignNos} from "@/assets/js/http-serve/http-methods";
  import {
    setCurrentUser
  } from "@/assets/js/http-serve/corp/common";
  // 组件
  import PublishSign from "@/components/publish-sign/sign";
  import ApplyMenuTree from "@/components/apply-menu-tree";
  import RouteName from "@/components/route-name";
  import ChangeAccount from "@/components/change-account";
  import RoleTab from "@/components/role-tab";
  import contractTabLeft from "@/components/signInfo/contractTabLeft";
  import contarctTable from "@/components/signInfo/contarctTable";
  // 数据
  import {gantConf} from "../assets/js/utils/jurisdiction";
  import {isInDingTalk} from "../assets/js/utils/ding-env";
  import {postSignCont} from "../assets/js/http-serve/http-methods";
  import {mapGetters} from "vuex";
  import GlobalConfig from "../assets/js/config/global";

  export default {
    data() {
      return {
        isInDingTalk,
        gantConf,
        tabsActive: "contract", // tabs 默认选择
        firstCreate: false, // 第一次创建
        moveDirResourceListSend: [], // 归档文件夹
        moveDirResourceListReceive: [], // 收件箱
        moveDirVisible: false,
        routePath: "",
        ignoreSignInfoLayout: [
          "/signInfo/insureClaim",
          "/signInfo/viewDetail",
          "/signInfo/viewGuide",
          ,
          "/derong/signInfo/viewDetail"
        ], // 不显示signInfo布局
        dirList: [], // 归档文件夹归档
        receivedDirList: [], // 收件箱归档
        moveDirList: [], // 移动归档
        dirType: -1, // 新增文件夹类型 1：归档文件夹 2：收件箱
        selectedApplys: [],
        choosenFolder: {},
        dialogFormVisible: false,
        showAllDirs: false,
        currentDir: {},
        badge: 0,
        currentMenuName: "", // 当前匹配的菜单名称，用于传递给routeName组件,
        activeName: window.location.pathname,
        batch: null,
        outerLinkMenu: [],
        signCount: {
          signNum: 0,
          endNum: 0,
        },
      };
    },
    components: {
      PublishSign,
      ApplyMenuTree,
      RouteName,
      RoleTab,
      contractTabLeft,
      contarctTable
    },
    watch: {
      $route: {
        handler({path}) {
          this.routePath = path;
          this.getpostSignCont();
        },
        deep: true
      },
      dialogFormVisible: {
        handler(val) {
          if (val === false) {
            this.currentDir = {};
          }
        }
      }
    },
    asyncData({route}) {
      return {routePath: route.path};
    },
    layout(context) {
      if (
        context.route.path.indexOf("toDetailAnony") !== -1 ||
        context.route.path.indexOf("viewDetail") !== -1
      ) {
        return "fullpage";
      } else {
        return "default";
      }
    },
    name: "signInfo",
    methods: {
      emitFn(fn) {
        this[fn]();
      },
      //获取数量统计
      getpostSignCont() {
        console.log(this.$route.path, 'pathsdasd')
        if (['/corp/signInfo/signList', '/signInfo/signList'].includes(this.$route.path)) {
          postSignCont().then(({data}) => {
            this.$store.dispatch("actionSingCountAll", data);
            this.signCount.signNum = this.signNumberFn([data.noFinishCount, data.myApplyNotSelfSignCount, data.ccToMeSignCount]);
            this.signCount.endNum = this.signNumberFn([data.finishCount, data.myFinishCount]);
          });
        }
      },
      //累加
      signNumberFn(arr) {
        return arr.reduce((prev, next) => {
          return prev + Number(next ? next : 0);
        }, 0)
      },
      batchLength(val) {
        this.batch = val;
      },
      toHistory() {
        let url = configUrl().entEbq + "/enterprise/contractPage";
        if (this.$store.getters.currentAuthUser.userType === 0) {
          url = configUrl().aresUrl + "/contract";
        }
        window.open(url, "_blank");
      },
      // 草稿箱删除操作
      deleteFromDir() {
        let selection = [];
        try {
          selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        } catch (e) {
          this.$message.error("无法获取选中的文件，请刷新重试");
          console.log(e);
        }
        if (selection.length === 0) {
          return this.$alert("请选择要删除的文件");
        }
        this.$confirm(
          '<p style="font-size: 16px;color: #000;">是否删除选中草稿文件?</p><p style="font-size: 12px;color: #949494;">删除后不会出现在草稿箱文件夹中</p>',
          "系统提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        )
          .then(async () => {
            let applySet = [];
            selection.forEach(apply => {
              applySet.push(apply.applyId);
            });
            let res = await ApiMethods.DirectoryController.draftDel({
              applyIds: applySet.join(",")
            });
            if (res.success) {
              this.$message.success(res.description || "移除文件成功");
              this.$refs["rightWrap"].getSignLists();
            } else {
              this.$message.error(res.description || "移除文件失败");
            }
          })
          .catch(() => {
          });
      },
      // 重新封装 moveDirList
      reloadMoveDirList() {
        this.moveDirList = [];
        // 归档文件夹
        if (this.currentPathDirType === 1) {
          this.moveDirResourceListSend.forEach(element => {
            // if (element.id.indexOf(this.$route.query.directoryId) === -1) {
            //
            // }
            let v = JSON.parse(JSON.stringify(element));
            v.nodeIcon = "tree-icon tree-icon7";
            this.moveDirList.push(v);
          });
          // this.moveDirList.unshift({
          //   id: `/signInfo/applyList?directoryId=-1`,
          //   label: "归档文件夹(未归档)",
          //   route: {
          //     path: "/signInfo/applyList",
          //     query: {
          //       match: -1
          //     }
          //   },
          //   nodeIcon: "tree-icon tree-icon4"
          // });
        }
        // 收件箱
        if (this.currentPathDirType === 2) {
          this.moveDirResourceListReceive.forEach(element => {
            // if (element.id.indexOf(this.$route.query.directoryId) === -1) {
            //
            // }
            let v = JSON.parse(JSON.stringify(element));
            v.nodeIcon = "tree-icon tree-icon7";
            this.moveDirList.push(v);
          });
          this.moveDirList.unshift({
            id: `/signInfo/signList?directoryId=-1`,
            label: "收件箱(未归档)",
            route: {
              path: "/signInfo/signList",
              query: {
                match: -1
              }
            },
            nodeIcon: "tree-icon tree-icon3"
          });
        }
      },
      // 移动归档合同
      dirMove() {
        // 收件箱
        this.reloadMoveDirList();
        let selection = [];
        try {
          selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        } catch (e) {
          this.$message.error("无法获取选中的文件，请刷新重试");
          console.log(e);
        }
        if (selection.length === 0) {
          return this.$alert("请选择归档文件");
        }
        this.selectedApplys = [];
        this.choosenFolder = {};
        selection.forEach(apply => {
          // 收集选中的所有合同
          this.selectedApplys.push(apply.directoryRelationId);
        });
        this.moveDirVisible = true;
      },
      async moveApplySignToDir() {
        if (!this.choosenFolder.index && this.choosenFolder.index !== 0) {
          return this.$message.error("请选择归档文件夹");
        }
        // 移除
        if (this.choosenFolder.index === 0 && false) {
          let param = {};
          param.directoryRelationIdSet = this.selectedApplys.join(",");
          param.directoryId = this.$route.query.directoryId;
          let res = await ApiMethods.DirectoryController.removeApplySignFromDir(
            param
          );
          this.moveDirVisible = false;
          this.choosenFolder = {};
          if (res.success) {
            this.$message.success(res.description || "归档文件成功");
            // 清空右边表格的选中状态
            if (
              this.$refs["rightWrap"] &&
              this.$refs["rightWrap"].$refs["dataList"]
            ) {
              this.$refs["rightWrap"].$refs["dataList"].clearSelection();
              this.$refs["rightWrap"].getSignLists();
            }
          } else {
            this.$message.error(res.description || "归档文件失败");
          }
        } else {
          // 移动
          let param = {};
          param.directoryRelationIdSet = this.selectedApplys.join(",");
          param.directoryId = this.$route.query.directoryId;
          param.targetDirectoryId = this.choosenFolder.route.query.directoryId;
          let res = await ApiMethods.DirectoryController.moveToTargetDir(param);
          this.moveDirVisible = false;
          this.choosenFolder = {};
          if (res.success) {
            this.$message.success(res.description || "归档文件成功");
            // 清空右边表格的选中状态
            if (
              this.$refs["rightWrap"] &&
              this.$refs["rightWrap"].$refs["dataList"]
            ) {
              this.$refs["rightWrap"].$refs["dataList"].clearSelection();
              this.$refs["rightWrap"].getSignLists();
            }
          } else {
            this.$message.error(res.description || "归档文件失败");
          }
        }
      },
      physicsDelete() {
        let selection = [];
        try {
          selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        } catch (e) {
          this.$message.error("无法获取选中的文件，请刷新重试");
          console.log(e);
        }
        if (selection.length === 0) {
          return this.$alert("请勾选要删除的签署信息。");
        }
        let signNos = [];
        selection.forEach(apply => {
          // 收集选中的所有合同
          signNos.push(apply.signInfoNo);
        });
        this.$confirm("该操作删除后的合同将无法恢复，确认删除？", "系统提示", {
          showCancelButton: true,
          showCancelButton: true,
          type: "info"
        })
          .then(() => {
            delSignBySignNos(signNos.join(","), this.$route.query.directoryId)
              .then(data => {
                this.$message.success("合同删除成功");
                // 清空右边表格的选中状态
                if (
                  this.$refs["rightWrap"] &&
                  this.$refs["rightWrap"].$refs["dataList"]
                ) {
                  this.$refs["rightWrap"].$refs["dataList"].clearSelection();
                  this.$refs["rightWrap"].getSignLists();
                }
              })
              .catch(err => {
                this.$message.error(
                  err.description || "删除合同失败，请刷新后再试！"
                );
              });
          })
          .catch(() => {
          });
      },

      initMenuTree() {
        this.queryDirectory({dirType: 1});
        this.queryDirectory({dirType: 2});
        this.getUserOuterLink();
      },
      // 查询归档文件夹列表
      async queryDirectory(opt) {
        let mergedOpt = opt || {};
        let param = {
          itemPage: 1,
          pageSize: 50,
          dirType: mergedOpt.dirType || 1
        };
        let res = await ApiMethods.DirectoryController.listByPage(param);
        if (res.success && res.data) {
          if (mergedOpt.dirType === 1) {
            this.dirList = [];
            this.moveDirResourceListSend = [];
          } else if (mergedOpt.dirType === 2) {
            this.receivedDirList = [];
            this.moveDirResourceListReceive = [];
          }
          res.data.forEach(dir => {
            let dirObj = {
              // id: `/signInfo/directoryManage?directoryId=${dir.directoryId}&applyType=${mergedOpt.dirType}`,
              id: `/signInfo/applyList?directoryId=${dir.directoryId}`,
              label: dir.name,
              route: {
                path: "/signInfo/applyList",
                query: {
                  directoryId: dir.directoryId
                }
              },
              slotClass: "showWhenHover",
              slots: [
                {
                  clickFunc: () => {
                    this.showDirDialog(dir);
                  },
                  iconClass: "el-icon-edit-outline",
                  hoverTitle: "重命名"
                },
                {
                  clickFunc: () => {
                    this.deleteDirectory(dir.directoryId, mergedOpt.dirType);
                  },
                  iconClass: "el-icon-delete",
                  hoverTitle: "删除"
                }
              ],
              nodeIcon: "tree-icon tree-icon7"
            };
            let receiveObj = {
              // id: `/signInfo/directoryManage?directoryId=${dir.directoryId}&applyType=${mergedOpt.dirType}`,
              id: `/signInfo/signList?directoryId=${dir.directoryId}`,
              label: dir.name,
              route: {
                path: "/signInfo/signList",
                query: {
                  directoryId: dir.directoryId
                }
              },
              slotClass: "showWhenHover",
              slots: [
                {
                  clickFunc: () => {
                    this.showDirDialog(dir);
                  },
                  iconClass: "el-icon-edit-outline",
                  hoverTitle: "重命名"
                },
                {
                  clickFunc: () => {
                    this.deleteDirectory(dir.directoryId, mergedOpt.dirType);
                  },
                  iconClass: "el-icon-delete",
                  hoverTitle: "删除"
                }
              ],
              nodeIcon: "tree-icon tree-icon7"
            };
            if (mergedOpt.dirType === 1) {
              // 归档文件夹
              this.dirList.push(dirObj);
              this.moveDirResourceListSend.push(dirObj);
              dirObj = null;
            } else if (mergedOpt.dirType === 2) {
              // 收件箱
              this.receivedDirList.push(receiveObj);
              this.moveDirResourceListReceive.push(receiveObj);
              receiveObj = null;
            }
          });

          // 调用树形菜单的resetTree方法
          this.$nextTick(() => {
            if (this.$refs.menuTree) {
              this.$refs.menuTree.resetTree();
            }
          });
        }
      },
      // 记录归档文件夹信息，并打开新增/修改窗口
      showDirDialog(dirObj) {
        if (this.accountInfoVO.identityAuth != 1) {
          this.$confirm(
            "您的账号还未完成实名认证，无法使用完整功能！",
            "提示",
            {
              confirmButtonText: "去认证",
              cancelButtonText: "以后再说",
              type: "warning"
            }
          )
            .then(() => {
              this.gotoAuth();
            })
            .catch(() => {
            });
        } else {
          if (dirObj !== undefined) {
            this.currentDir = JSON.parse(JSON.stringify(dirObj));
          } else {
            this.currentDir = {};
          }
          this.dialogFormVisible = true;
        }
      },
      gotoAuth () {
        if (this.$store.getters.authUser.userType === 0) {
          this.$router.push("/auth/personalIdentityAuth");
        } else {
          this.$router.push("/auth/authGuide");
        }
      },
      // 创建归档文件夹
      createOrUpdateDir() {
        if (!this.currentDir.name) return this.$message.error("请输入文件夹名称");
        if (this.currentDir.name.length > 10)
          return this.$message.error("文件夹名称不能超过10个字符");
        let param = this.currentDir;
        if (param.directoryId) {
          // 修改
          ApiMethods.DirectoryController.update(param).then(result => {
            if (result.success) {
              this.dialogFormVisible = false;
              if (param.dirType === 1) {
                this.queryDirectory({dirType: 1});
              } else if (param.dirType === 2) {
                this.queryDirectory({dirType: 2});
              }
              this.$message.success(result.description || "操作成功");
            } else {
              this.$message.error(result.description || this.$tip);
            }
          });
        } else {
          // 判断是不是点击加号来的 -1: 不是  1、2：是
          if (this.dirType === -1) {
            // 通过计算属性，获取url对应的dirType
            param.dirType = this.currentPathDirType;
          } else {
            // 通过点击加号获取的dirType
            param.dirType = this.dirType;
            // 还原到点击前
            this.dirType = -1;
          }
          // 新增
          ApiMethods.DirectoryController.create(param).then(result => {
            if (result.success) {
              this.dialogFormVisible = false;
              // 是否第一次添加
              if (this.firstCreate) {
                this.firstCreate = false;
                // 获取右边表格的选中状态
                if (
                  this.$refs["rightWrap"] &&
                  this.$refs["rightWrap"].$refs["dataList"]
                ) {
                  let selection = this.$refs["rightWrap"].$refs["dataList"]
                    .selection;
                  if (selection.length === 0) {
                    this.$alert("请选择归档文件");
                  } else {
                    this.selectedApplys = [];
                    this.choosenFolder = {};
                    selection.forEach(apply => {
                      // 收集选中的所有合同
                      this.selectedApplys.push(apply.applyId);
                    });
                    this.showAllDirs = false;
                    // 保存合同
                    let saveParam = {};
                    saveParam.applyIdSet = this.selectedApplys.join(",");
                    saveParam.directoryId = result.data.directoryId;
                    ApiMethods.DirectoryController.saveApplySignToDir(saveParam)
                      .then(res => {
                        if (res.success) {
                          this.$message.success(
                            res.description || "归档文件成功"
                          );
                          // 清空右边表格的选中状态
                          if (
                            this.$refs["rightWrap"] &&
                            this.$refs["rightWrap"].$refs["dataList"]
                          ) {
                            this.$refs["rightWrap"].$refs[
                              "dataList"
                              ].clearSelection();
                            this.$refs["rightWrap"].getSignLists();
                          }
                          // 正常流程
                          if (param.dirType === 1) {
                            this.$router.push({
                              path: "/signInfo/applyList",
                              query: {directoryId: result.data.directoryId}
                            });
                            this.queryDirectory({dirType: 1});
                          } else if (param.dirType === 2) {
                            this.$router.push({
                              path: "/signInfo/signList",
                              query: {directoryId: result.data.directoryId}
                            });
                            this.queryDirectory({dirType: 2});
                          }
                        } else {
                          this.$message.error(res.description || "归档文件失败");
                        }
                      })
                      .catch(() => {
                      });
                  }
                }
              } else {
                // 正常流程
                if (param.dirType === 1) {
                  this.$router.push({
                    path: "/signInfo/applyList",
                    query: {directoryId: result.data.directoryId}
                  });
                  this.queryDirectory({dirType: 1});
                } else if (param.dirType === 2) {
                  this.$router.push({
                    path: "/signInfo/signList",
                    query: {directoryId: result.data.directoryId}
                  });
                  this.queryDirectory({dirType: 2});
                }
                this.$message.success(result.description || "操作成功");
              }
            } else {
              this.$message.error(result.description || this.$tip);
            }
          });
        }
      },
      // 删除归档文件夹
      deleteDirectory(directoryId, dirType) {
        this.$confirm(
          '是否删除当前文件夹？',
          "系统提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        )
          .then(() => {
            let param = {directoryId: directoryId};
            ApiMethods.DirectoryController.delete(param).then(result => {
              if (result.success) {
                if (parseInt(result.data) === 0) {
                  this.$confirm(
                    '<p style="font-size: 16px;color: #000;">无法删除当前文件夹</p><p>请先将归档文件移至其他文件夹</p>',
                    "系统提示",
                    {
                      confirmButtonText: "知道了",
                      showCancelButton: false,
                      type: "warning",
                      dangerouslyUseHTMLString: true
                    }
                  )
                    .then(() => {
                    })
                    .catch(() => {
                    });
                  return;
                }
                if (dirType) {
                  this.queryDirectory({dirType});
                  if (dirType === 1) {
                    this.$router.push({
                      path: "/signInfo/applyList",
                      query: {directoryId: result.data.directoryId}
                    });
                  } else if (dirType === 2) {
                    this.$router.push({
                      path: "/signInfo/signList",
                      query: {directoryId: result.data.directoryId}
                    });
                  }
                } else {
                  this.queryDirectory({dirType: 1});
                  this.queryDirectory({dirType: 2});
                }
                this.$message.success(result.description || "操作成功");
              } else {
                this.$message.error(result.description || "删除文件夹失败");
              }
            });
          })
          .catch(() => {
          });
      },
      //给applyListNew 和signListNew这两个组件单独用的
      saveToDirNew(selection) {
        // let selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        if (selection.length === 0) {
          this.$alert("请选择归档文件");
        } else {
          this.selectedApplys = [];
          this.choosenFolder = {};
          selection.forEach(apply => {
            this.selectedApplys.push(apply.applyId);
          });
          this.showAllDirs = true;
        }
      },
      // 临时存储归档文件的applyId
      saveToDir() {
        this.firstCreate = false;
        // 归档文件夹归档
        if (this.currentPathDirType === 1 && this.dirList.length === 0) {
          this.firstCreate = true;
          return this.$alert("请先创建归档文件夹")
            .then(() => {
              this.dialogFormVisible = true;
            })
            .catch(() => {
            });
        }
        // 收件箱归档
        else if (
          this.currentPathDirType === 2 &&
          this.receivedDirList.length === 0
        ) {
          this.firstCreate = true;
          return this.$alert("请先创建归档文件夹")
            .then(() => {
              this.dialogFormVisible = true;
            })
            .catch(() => {
            });
        }
        // 获取右边表格的选中状态
        if (
          this.$refs["rightWrap"] &&
          this.$refs["rightWrap"].$refs["dataList"]
        ) {
          let selection = this.$refs["rightWrap"].$refs["dataList"].selection;
          if (selection.length === 0) {
            this.$alert("请选择归档文件");
          } else {
            this.selectedApplys = [];
            this.choosenFolder = {};
            selection.forEach(apply => {
              // 收集选中的所有合同
              this.selectedApplys.push(apply.applyId);
            });
            this.showAllDirs = true;
          }
        }
      },
      // 归档文件接口
      async saveApplySignToDir() {
        if (!this.choosenFolder.index && this.choosenFolder.index !== 0) {
          return this.$message.error("请选择归档文件夹");
        }
        let param = {};
        param.applyIdSet = this.selectedApplys.join(",");
        param.directoryId = this.choosenFolder.route.query.directoryId;
        let res = await ApiMethods.DirectoryController.saveApplySignToDir(param);
        this.showAllDirs = false;
        this.choosenFolder = {};
        if (res.success) {
          this.$message.success(res.description || "归档文件成功");
          // 清空右边表格的选中状态
          if (
            this.$refs["rightWrap"] &&
            this.$refs["rightWrap"].$refs["dataList"]
          ) {
            this.$refs["rightWrap"].$refs["dataList"].clearSelection();
            this.$refs["rightWrap"].getSignLists();
          } else {
            //清除applyListNew 、signListNew组件的操作
            Bus.$emit("$saveToDirNewEndClear1")
          }
        } else {
          this.$message.error(res.description || "归档文件失败");
        }
      },
      // 删除文件
      removeFromDir() {
        let selection = [];
        try {
          selection = this.$refs["rightWrap"].$refs["dataList"].selection;
        } catch (e) {
          this.$message.error("无法获取选中的文件，请刷新重试");
          console.log(e);
        }
        if (selection.length === 0) {
          return this.$alert("请选择要移除的文件");
        }
        this.$confirm(
          '<p style="font-size: 16px;color: #000;">是否移除文件?</p><p style="font-size: 12px;color: #949494;">移除后不会出现在当前归档文件夹中</p>',
          "系统提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        )
          .then(async () => {
            let applySet = [];
            selection.forEach(apply => {
              applySet.push(apply.directoryRelationId);
            });
            let res = await ApiMethods.DirectoryController.removeApplySignFromDir(
              {
                directoryId: this.$route.query.directoryId,
                directoryRelationIdSet: applySet.join(",")
              }
            );
            if (res.success) {
              this.$message.success(res.description || "移除文件成功");
              this.$refs["rightWrap"].getSignLists();
            } else {
              this.$message.error(res.description || "移除文件失败");
            }
          })
          .catch(() => {
          });
      },
      chooseFolder(folder, index) {
        this.choosenFolder = Object.assign({}, folder);
        this.choosenFolder.index = index;
      },

      async getUserOuterLink() {
        let res = await ApiMethods.ProfileController.getUserOuterLink({
          outerLinkLocation: 1
        });
        this.outerLinkMenu = [];
        if (res.success && res.data) {
          let data = res.data;
          for (let i = 0; i < data.length; i++) {
            let d = data[i];
            let l;
            if (d.outerLink.startsWith("http")) {
              let ym = d.outerLink.match(/https?:\/\/.*?([\/|\?][^]+)/i);
              let domin = "";
              if (ym && ym[1]) {
                domin = ym[1];
              }
              l = {
                // id: d.outerLink,
                id: domin,
                label: d.outerLinkName,
                href: {
                  path: d.outerLink,
                  // path:domin,
                  target: "_self"
                },
                // badge: this.badge,
                nodeIcon: "tree-icon tree-icon10",
                slotClass: "separated"
              };
            } else {
              l = {
                id: d.outerLink,
                label: d.outerLinkName,
                route: {
                  path: d.outerLink,
                  query: {}
                },
                nodeIcon: "tree-icon tree-icon10",
                slotClass: "separated"
              };
            }
            this.outerLinkMenu.push(l);
          }
        }

        // 调用树形菜单的resetTree方法
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.resetTree();
          }
        });
      }
    },
    head() {
      return {
        title: "文件管理"
      };
    },
    computed: {
      ...mapGetters([
        'allAuthUser'
      ]),
      accountInfoVO() {
        if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
          return this.allAuthUser.accountInfoVO;
        }
        return {};
      },
      // 获取权限数组菜单
      getPerms() {
        let perms = this.$store.getters.consoleToken;
        perms = perms ? perms.perms : [];
        return perms;
      },
      personMenus() {
        const menus = [
          // {
          //   id: "/title_1",
          //   label: "----- 我参与签署的 -----",
          //   route: {
          //     path: "/title_1"
          //   },
          //   badge: this.badge,
          //   nodeIcon: ""
          // },
          {
            label: "待签的",
            id: "/signInfo/signList?signStatus=2",
            route: {
              path: "/signInfo/signList",
              query: {signStatus: 2}
            },
            badge: this.signCount.signNum,
            nodeIcon: "tree-icon tree-icon1"
          },
          {
            id: "/signInfo/signList?signStatus=3",
            label: "已结束",
            route: {
              path: "/signInfo/signList",
              query: {signStatus: 3}
            },
            badge: this.signCount.endNum,
            nodeIcon: "tree-icon tree-icon2",
            slotClass: ""
          },
          // {
          //   label: "我发给他人的",
          //   id: "/signInfo/applyList?notMeSign=1",
          //   route: {
          //     path: "/signInfo/applyList",
          //     query: { notMeSign: 1 }
          //   },
          //   badge: this.badge,
          //   nodeIcon: "tree-icon tree-icon1",
          //   slotClass: "separated"
          // },
          {
            id: "/signInfo/applyList?signStatus=4",
            label: "草稿箱",
            route: {
              path: "/signInfo/applyList",
              query: {signStatus: 4}
            },
            badge: this.badge,
            nodeIcon: "tree-icon tree-icon5",
            slotClass: "separated"
          },
          {
            id: "/signInfo/applyList?match=-1",
            label: "归档文件夹",
            routeName: "归档文件夹（未归档）",
            route: {
              path: "/signInfo/applyList",
              query: {match: -1}
            },
            badge: this.badge,
            // slotClass: "showWhenHover",
            slotClass: "separated",
            slots: [
              {
                clickFunc: () => {
                  this.dirType = 1;
                  this.showDirDialog();
                },
                iconClass: "el-icon-folder-add",
                hoverTitle: "添加归档文件夹"
              }
            ],
            children: this.dirList,
            nodeIcon: "tree-icon tree-icon3"
          },
          this.changeAccount
        ];
        if (!isInDingTalk) {
          // 钉钉微应用 不要 文件保全入口
          menus.push({
            id: "/signInfo/preservation",
            label: "文件保全",
            route: {
              path: "/signInfo/preservation",
              query: {}
            },
            badge: this.badge,
            nodeIcon: "tree-icon tree-icon_bq",
            slotClass: "separated"
          });
        }
        return menus;
      },
      entMenus() {
        let menus = [
          {
            label: "待签的",
            id: "/signInfo/signList?signStatus=2",
            route: {
              path: "/signInfo/signList",
              query: {signStatus: 2}
            },
            badge: this.signCount.signNum,
            nodeIcon: "tree-icon tree-icon1"
          },
          {
            id: "/signInfo/signList?signStatus=3",
            label: "已结束",
            route: {
              path: "/signInfo/signList",
              query: {signStatus: 3}
            },
            badge: this.signCount.endNum,
            nodeIcon: "tree-icon tree-icon2",
            slotClass: ""
          },
          // {
          //   label: "我发给他人的",
          //   id: "/signInfo/applyList?notMeSign=1",
          //   route: {
          //     path: "/signInfo/applyList",
          //     query: { notMeSign: 1 }
          //   },
          //   badge: this.badge,
          //   nodeIcon: "tree-icon tree-icon1",
          //   slotClass: "separated"
          // },
          {
            id: "/signInfo/applyList?signStatus=4",
            label: "草稿箱",
            route: {
              path: "/signInfo/applyList",
              query: {signStatus: 4}
            },
            badge: this.badge,
            nodeIcon: "tree-icon tree-icon5",
            slotClass: "separated"
          },
          // {
          //   id: "/signInfo/signList?match=-1",
          //   label: "收件箱",
          //   routeName: "收件箱（未归档）",
          //   route: {
          //     path: "/signInfo/signList",
          //     query: { match: -1 }
          //   },
          //   badge: this.badge,
          //   slotClass: "showWhenHover",
          //   slots: [
          //     {
          //       clickFunc: () => {
          //         this.dirType = 2;
          //         this.showDirDialog();
          //       },
          //       iconClass: "el-icon-folder-add",
          //       hoverTitle: "添加归档文件夹"
          //     }
          //   ],
          //   children: this.receivedDirList,
          //   nodeIcon: "tree-icon tree-icon3"
          // },
          {
            id: "/signInfo/preservation",
            label: "文件保全",
            route: {
              path: "/signInfo/preservation",
              query: {}
            },
            badge: this.badge,
            nodeIcon: "tree-icon tree-icon_bq",
            slotClass: "separated"
          },
          {
            id: "/signInfo/applyList?match=-1",
            label: "归档文件夹",
            routeName: "归档文件夹（未归档）",
            route: {
              path: "/signInfo/applyList",
              query: {match: -1}
            },
            badge: this.badge,
            // slotClass: "showWhenHover",
            slotClass: "separated",
            slots: [
              {
                clickFunc: () => {
                  this.dirType = 1;
                  this.showDirDialog();
                },
                iconClass: "el-icon-folder-add",
                hoverTitle: "添加归档文件夹"
              }
            ],
            children: this.dirList,
            nodeIcon: "tree-icon tree-icon3"
          },
          this.changeAccount,
          ...this.outerLinkMenu
        ];
        return menus.filter(item => item);
      },
      APIentMenus() {
        let menus = [
          this.$store.getters.currentAuthUser &&
          this.$store.getters.currentAuthUser.merchantFlag === 1
            ? {
              id: "tree6",
              label: "API对接",
              children: [
                {
                  id: "/signInfo/entAccess?typeStatus=apiSet",
                  label: "API签署管理",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "apiSet"}
                  }
                },
                {
                  id: "/signInfo/entAccess?typeStatus=entAuth",
                  label: "企业认证管理",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "entAuth"}
                  }
                },
                {
                  id: "/signInfo/entAccess?typeStatus=signCallback",
                  label: "签署回调记录",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "signCallback"}
                  }
                },
                {
                  id: "/signInfo/entAccess?typeStatus=entSign",
                  label: "企业认证回调记录",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "entSign"}
                  }
                },
                {
                  id: "/signInfo/entAccess?typeStatus=setUrl",
                  label: "回调地址设置",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "setUrl"}
                  }
                },
                {
                  id: "/signInfo/viewDealTypeList",
                  label: "保全存证",
                  route: {
                    path: "/signInfo/viewDealTypeList"
                  }
                },
                {
                  id: "/signInfo/entAccess?typeStatus=appkeyManage",
                  label: "APPKEY管理",
                  route: {
                    path: "/signInfo/entAccess",
                    query: {typeStatus: "appkeyManage"}
                  }
                },
                // {
                //   id: "/signInfo/entAccess?typeStatus=digital_certificate",
                //   label: "数字证书授权",
                //   route: {
                //     path: "/signInfo/entAccess",
                //     query: { typeStatus: "digital_certificate" }
                //   }
                // },
              ],
              nodeIcon: "tree-icon tree-icon8",
              slotClass: "separated"
            }
            : null,
        ];
        //手写签字的权限 + API当前列表是否存在
        if (this.accountInfoVO && this.accountInfoVO.handSealCheckScore && this.$store.getters.currentAuthUser &&
          this.$store.getters.currentAuthUser.merchantFlag === 1) {
          menus[0].children.push({
            id: "/signInfo/entAccess?typeStatus=sign_check",
            label: "手写签字校验",
            route: {
              path: "/signInfo/entAccess",
              query: {typeStatus: "sign_check"}
            }
          })
        }
        //电子签名API 接口介绍
        menus = menus.concat([
          {
            id: "/signInfo/entAccess?typeStatus=interface_doc",
            label: "电子签名API接口介绍",
            href: {
              path: GlobalConfig.domain.junziqianApi + '/api_doc/index.html',
              // path:domin,
              target: "_blank"
            },
          },
          {
            id: "/console/template",
            label: "API模板",
            route: {
              path: "/console/template",
              query: {apiTem: "1"}
            }
          }
        ])
        return menus.filter(item => item);
      },
      APIpath() {
        return this.$route.path === '/signInfo/viewDealTypeList' || this.$route.path === '/signInfo/entAccess'
      },
      changeAccount() {
        // try {
        //   if (this.$store.getters.allAuthUser.bindCorpUsers.length > 0) {
        //     return {
        //       id: 'changeUserInfo',
        //       label: '切换签署主体',
        //       children: [
        //         {
        //           id: 'searchUserInfo',
        //           component: {
        //             template: ChangeAccount,
        //             class: {
        //               marginLeft: '-25px',
        //             },
        //           },
        //         },
        //       ],
        //       nodeIcon: 'tree-icon tree-icon9',
        //     };
        //   }
        //   return {};
        // } catch (e) {
        //   return {};
        // }

        // 改版后，不渲染 “切换签署主体”
        return {};
      },
      showMenuTree() {
        let showTree = true;
        this.ignoreSignInfoLayout.forEach(path => {
          if (path === this.$route.path) {
            showTree = false;
          }
        });
        return showTree;
      },
      currentAuthUser() {
        return this.$store.getters.currentAuthUser || {};
      },
      menus() {
        if (this.APIpath) {
          return this.APIentMenus;
        } else if (this.currentAuthUser.userType == 0) {
          return this.personMenus;
        } else if (this.currentAuthUser.userType == 1) {
          return this.entMenus;
        }
        return [];
      },
      // 是否显示 归档 按钮
      showDirBtn() {
        let path = this.$route.fullPath;
        let showBtnRoutes = [
          "/signInfo/signList?match=-1",
          "/signInfo/applyList?match=-1"
        ];
        for (let i = 0, length = showBtnRoutes.length; i < length; i++) {
          if (path.indexOf(showBtnRoutes[i]) != -1 && this.batch) {
            return true;
          }
        }
        return false;
      },
      currentPathDirType() {
        if (this.$route.path === "/signInfo/signList") {
          // 当前路由是收件箱
          // return 2;
          return 1;
        } else if (this.$route.path === "/signInfo/applyList") {
          // 当前路由是归档文件夹
          // return this.$route.query.notMeSign ? 2 : 1;
          return 1;
        }
        return -1;
      },
      computedCurrentMenuName() {
        return this.currentMenuName;
      }
    },
    created() {
      if (this.$route.query.tabsActive) {
        this.tabsActive = this.$route.query.tabsActive;
      }
      this.getpostSignCont() //数量统计
      //专为 applyListNew 、signListNew组件使用（navTab切换的页面的 归档按钮）
      Bus.$on("$saveToDirNew1", (obj) => {
        console.log('bus-on:guidang1')
        this.saveToDirNew(obj.selection);
      })
      console.log('guazai------------', Bus)
      //获取外链配置
      /*outerLinkLocation  外链显示位置(1:SAAS文件管理-PC 2:业务通首页 3:业务通菜单)*/
    },
    destroyed() {
      console.log('xiaohui======')
      Bus.$off('$saveToDirNew1');
    },
  };
</script>

<style lang="less" scoped>
  // .tabs-style /depp/ .el-tabs__item {
  //   :hover {
  //     color: #ec1c1c;
  //   }
  //   .is-active {
  //     color: #ec1c1c;
  //   }
  // }
  // .tabs-style /depp/ .el-tabs__active-bar {
  //   background-color: #ec1c1c;
  // }
  .row-header {
    max-width: 1200px;
    margin: 0 auto;
  }

  .main-wrap {
    display: flex;
    justify-content: space-between;

    .left-wrap {
      padding: 0 0 15px;
      width: 230px;
      background-color: #ffffff;

      .dindin_code {
        padding-top: 10px;
        text-align: center;

        .code_img {
          width: 180px;
          height: 180px;
        }
      }

      /deep/ .publish {
        padding: 15px 0;
        text-align: left;
        border-bottom: solid 1px #e6e6e6;

        .upload-file {
          width: 80%;
          margin-left: 10%;

          input[type="file"] {
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }

          .el-button {
            width: 100%;
          }
        }

        .tpl {
          width: 80%;
          margin-left: 10%;
          margin-bottom: 0;
        }
      }
    }

    .right-wrap {
      min-height: 75vh;
      position: relative;
      flex-grow: 1;
      max-width: calc(100% - 235px);
      margin-left: 5px;
      background-color: #ffffff;

      .table-wrap {
        padding: 0 16px;
      }

      /deep/ .row {
        padding: 15px;
        height: 62px;
        min-height: 62px;
      }

      /deep/ .data-list {
        /*height: calc(100vh - 296px - 70px);*/
        width: inherit;
        margin: 0 15px;
        border: 1px solid #eeeeee;
      }

      /deep/ .el-table__body-wrapper {
        /*height: calc(100% - 48px);*/
        overflow-y: auto;
      }

      #nuxt-view /deep/ .go-style {
        top: 17px;
      }

      // /deep/ .el-button {
      //   background: rgba(236, 28, 28, 1);
      //   color: #ffffff;

      //   &:hover {
      //     opacity: 0.7;
      //   }
      // }
    }
  }

  nav.menu {
    overflow: hidden;
    margin-top: 10px;

    .nav-bar {
      width: 100%;

      .nav-item {
        font-size: 15px;
        color: #666666;
        margin-right: 40px;
      }

      .nav-item:before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 18px;
        background: #ffffff;
        vertical-align: middle;
        margin-right: 6px;
      }

      .nav-item.active:before {
        background: #ec1c1c;
      }

      .nav-item.active {
        color: #ec1c1c;

        .span {
          color: #ec1c1c;
        }
      }
    }
  }

  .save-to-dir {
    margin-right: 36%;

    li {
      padding: 6px 11px;
      cursor: pointer;
      border-radius: 4px;

      &:before {
        content: "";
        display: inline-block;
        width: 24px;
        height: 19px;
        margin-right: 5px;
        background-image: url("/images/icon/icon-folder.png");
        background-size: 100%;
        background-repeat: no-repeat;
        vertical-align: top;
        opacity: 0.6;
      }

      &:hover {
        background-color: #f1f1f1;
      }

      &.active {
        background-color: #f1f1f1;
      }
    }
  }

  .move-to-dir {
    li {
      padding: 6px 11px;
      cursor: pointer;
      border-radius: 4px;

      &:hover {
        background-color: #f1f1f1;
      }

      &.active {
        background-color: #f1f1f1;
      }
    }

    .tree-icon {
      display: inline-block;
      width: 15px;
      height: 15px;
      vertical-align: middle;
      margin-right: 5px;
      background-image: url("/images/icon/tree-icon.png");
      background-repeat: no-repeat;
      background-size: cover;

      &.tree-icon1 {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/file-weiwancheng.png");
        background-size: cover;
        background-position: 0 0;
      }

      &.tree-icon2 {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/file-jieshu.png");
        background-size: cover;
      }

      &.tree-icon3 {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/shoujian.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon4 {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/fasong.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon5 {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/file-caogaoxiang.png");
        background-size: 37px;
        background-position: -8px -8px;
      }

      &.tree-icon_bq {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-image: url("/images/baoquan.png");
        background-size: cover;
        background-position: 0;
      }

      &.tree-icon6 {
        background-image: url("/images/weiquan.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon7 {
        background-image: url("/images/wenjianjia.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon8 {
        background-position: 0 0 !important;
        background-size: 500% 500% !important;
      }

      &.tree-icon9 {
        background-image: url("/images/qiehuan.png");
        background-size: 16px;
        background-position: 4px 2px;
      }

      &.tree-icon10 {
        display: inline-block;
        width: 23px;
        height: 23px;
        background-image: url("/images/shuju.png");
      }
    }
  }

  /deep/ .dialog-height {
    & > .el-dialog {
      .el-dialog__header {
        position: relative;
        background-color: transparent;
        padding: 4px 16px;

        .el-dialog__title {
          font-size: 16px;
          font-weight: 600;
        }

        .el-dialog__headerbtn {
          top: 0;
          bottom: 0;
          margin: auto 0;
        }

        .el-dialog__headerbtn:hover .el-dialog__close {
          color: #ec1c1c;
        }
      }

      .el-dialog__body {
        max-height: 60vh;
        overflow-y: auto;
        padding: 18px;
        border-top: solid 1px #e5e5e5;
        border-bottom: solid 1px #e5e5e5;
      }

      .el-dialog__footer {
        padding: 11px 14px;

        .el-button {
          padding: 7px 25px;
        }
      }
    }
  }

  /deep/ .menu-tree {
    .tree-icon {
      display: inline-block;
      width: 15px;
      height: 15px;
      vertical-align: middle;
      margin-right: 5px;
      background-image: url("/images/icon/tree-icon.png");
      background-repeat: no-repeat;
      background-size: cover;

      &.tree-icon1 {
        background-image: url("/images/file-weiwancheng.png");
        background-size: cover;
      }

      &.tree-icon2 {
        background-image: url("/images/file-jieshu.png");
        background-size: cover;
      }

      &.tree-icon3 {
        background-image: url("/images/shoujian.png");
        background-size: cover;
      }

      &.tree-icon4 {
        background-image: url("/images/fasong.png");
        background-size: cover;
      }

      &.tree-icon5 {
        background-image: url("/images/file-caogaoxiang.png");
        background-size: cover;
      }

      &.tree-icon_bq {
        background-image: url("/images/baoquan.png");
        background-size: cover;
      }

      &.tree-icon6 {
        background-image: url("/images/weiquan.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon7 {
        background-image: url("/images/wenjianjia.png");
        background-position: 0;
        background-size: cover;
      }

      &.tree-icon8 {
        background-position: 0 0 !important;
        background-size: 500% 500% !important;
      }

      &.tree-icon9 {
        background-image: url("/images/qiehuan.png");
        background-size: 16px;
        background-position: 4px 2px;
      }

      &.tree-icon10 {
        width: 23px !important;
        height: 23px !important;
        background-image: url("/images/shuju.png");
        background-position: 0;
        background-size: cover;
      }
    }

    .is-checked > .el-tree-node__content {
      .tree-icon.tree-icon1 {
        background-image: url("/images/file-weiwanchengHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon2 {
        background-image: url("/images/file-jieshuHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon3 {
        background-image: url("/images/shoujianHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon4 {
        background-image: url("/images/fasongHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon5 {
        background-image: url("/images/file-caogaoxiangHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon_bq {
        background-image: url("/images/baoquanHover.png");
        background-size: cover;
      }

      .tree-icon.tree-icon6 {
        background-image: url("/images/weiquan.png");
        background-position: 0;
        background-size: cover;
      }

      .tree-icon.tree-icon7 {
        background-image: url("/images/wenjianjia.png");
      }

      .tree-icon.tree-icon8 {
        background-position: 0 0 !important;
        background-size: 500% 500% !important;
      }

      .tree-icon.tree-icon10 {
        background-image: url("/images/shuju.png");
        background-position: 0;
        background-size: 100% 100%;
      }
    }
  }

  /deep/ .change-account {
    .photo {
      width: 24px;
      height: 24px;
    }

    .current-user {
      .el-icon-check {
        font-size: 18px;
      }
    }
  }

  // /deep/ .el-tree-node__content {
  //   height: auto !important;
  // }
</style>

<style lang="less">
  nav.nav-bar {
    .el-badge__content.is-fixed {
      right: 0;
    }
  }

  .el-tabs__nav-scroll {
    /*padding-left: 25px;*/
  }

  .el-tabs--bottom .el-tabs__header.is-bottom {
    margin-top: 0;
  }

  .el-tabs__item {
    font-weight: bold;
    font-size: 15px;
    padding: 0 12px !important;
  }

  .el-tabs__active-bar {
    color: #ec1c1c;
    background-color: #ec1c1c;
  }

  .el-tabs__item.is-active {
    color: #ec1c1c;
  }

  .el-tabs__item:hover {
    color: #ec1c1c;
  }

  .el-tabs__nav-wrap::after {
    height: 1px;
  }
</style>



// WEBPACK FOOTER //
// pages/signInfo.vue